import type { MouseEventHandler } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface BookingCardDetailsButtonProps {
  title: string
  subtitle: string
  onClick?: MouseEventHandler<HTMLButtonElement>
  className?: string
}

export const BookingCardDetailsButton = ({
  title,
  subtitle,
  onClick,
  className,
}: BookingCardDetailsButtonProps) => (
  <button
    type="button"
    className={clsx(s.button, className)}
    onClick={onClick}
  >
    <div className={s.text}>
      <span className={clsx('semi-bold-14', s.title)}>{title}</span>
      <span className={clsx('regular-12', s.subtitle)}>{subtitle}</span>
    </div>

    <AppIcon
      id={AllIcons.CHEVRON_CELL}
      width={24}
      height={24}
      className={s.icon}
    />
  </button>
)
